/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type FeaturedCommentsContainer_settings = {
    readonly reaction: {
        readonly sortLabel: string;
    };
    readonly " $fragmentRefs": FragmentRefs<"FeaturedCommentContainer_settings">;
    readonly " $refType": "FeaturedCommentsContainer_settings";
};
export type FeaturedCommentsContainer_settings$data = FeaturedCommentsContainer_settings;
export type FeaturedCommentsContainer_settings$key = {
    readonly " $data"?: FeaturedCommentsContainer_settings$data;
    readonly " $fragmentRefs": FragmentRefs<"FeaturedCommentsContainer_settings">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "FeaturedCommentsContainer_settings",
    "selections": [
        {
            "alias": null,
            "args": null,
            "concreteType": "ReactionConfiguration",
            "kind": "LinkedField",
            "name": "reaction",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "sortLabel",
                    "storageKey": null
                }
            ],
            "storageKey": null
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "FeaturedCommentContainer_settings"
        }
    ],
    "type": "Settings",
    "abstractKey": null
} as any);
(node as any).hash = 'ba246b49923db157064098a94f8f83d8';
export default node;
